import { IconFileDescription} from '@tabler/icons-react';
import { API } from 'utils/api';

function transformNode(node) {
  const newNode = {
    id: String(node.id), // 转换id为字符串
    title: node.title, // 直接迁移title
    type: node.content ? 'item' : 'collapse', // 根据content判断type
    icon: IconFileDescription, // 不变
    breadcrumbs: false, // 不变
    isAdmin: false, // 不变
  };

  if (node.content) {
    newNode.url = `/panel/document?id=${node.id}`; // 设置url，假设格式为'/panel/text-doc/{id}'
  }

  if (node.children && node.children.length > 0) {
    newNode.children = node.children.map(child => transformNode(child)); // 递归处理子节点
  }

  return newNode;
}

const getDocumentMenu = async () => {

  var result = {
    id: 'panel',
    type: 'group',
    children: [
      {
        id: '0',
        title: '文档为空',
        type: 'item',
        url: '/panel/document',
        icon: IconFileDescription,
        breadcrumbs: false,
        isAdmin: false
      }
    ]
  };

  var url = `/api/document/`;
  const res = await API.get(url);
  const { success, message, data, total } = res.data;
  if (success) {
    const transformedData = data.map(item => transformNode(item))
    result.children = transformedData;
  }

  return result;
};

export { getDocumentMenu };
